if (!customElements.get('custom-product-cta')) {
    customElements.define('custom-product-cta', class extends HTMLElement {
        constructor() {
            super();

            // get the product form
            this.productForm = this.querySelector('product-form');

            // get the submit button
            this.productFormSubmit = this.productForm.querySelector('button[type="submit"]');

            // get the trigger submit button
            this.productTriggerSubmit = this.querySelectorAll('[data-product-form-buy]');
            
            // get the expo day and hour
            // console.log('this.dataset', this.dataset);
            this.expoDay = this.dataset.expoday;
            this.expoHour = this.dataset.expohour;
            this.complexe = this.dataset.complexe;
        }

        connectedCallback() {
            // add event listener to the trigger submit button
            this.productTriggerSubmit.forEach(submitTrigger => {
                submitTrigger.addEventListener('click', this.handleTriggerSubmit.bind(this));
            });

            // check for buying restriction
            this.handleBuyingRestriction();
        }

        disconnectedCallback() {
            // remove event listener from the trigger submit button
            this.productTriggerSubmit.forEach(submitTrigger => {
                submitTrigger.removeEventListener('click', this.handleTriggerSubmit.bind(this));
            });
        }

        handleBuyingRestriction() {
            // check if the buying is restricted
            // console.log('checking buying restriction', this.expoDay, this.expoHour);
            let isBuyingValid = window.isAvisHasValidDate(this.expoDay, this.expoHour)
                                && window.isAvisHasValidComplexe(this.complexe);

            if (!isBuyingValid) {
                console.log('Buying is restricted');
                this.classList.add('isRestricted');
            }
            else {
                console.log('Buying is not restricted');
                this.classList.remove('isRestricted');
            }
        }

        handleTriggerSubmit(event) {
            event.preventDefault();
            // console.log('handleTriggerSubmit');

            //
            this.productFormSubmit.click();
        }
    });
}